import { Analysis, PossibleRootCauseCategory } from '.';

export class LipidsAnalysis extends Analysis {
    calculateInsights() {
        if (this.ba.cholesterol.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_16000);
        } else if (this.ba.cholesterol.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_16010);
        }

        if (this.ba.hdl.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_16020);
        } else if (this.ba.hdl.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_16030);
        }

        if (this.ba.triglycerides.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_16040);
        } else if (this.ba.triglycerides.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_16050);
        }

        if (this.ba.ldl.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_16060);
        } else if (this.ba.ldl.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_16070);
        }

        if (this.ba.cholesterolHDLRatio.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_16080);
        }

        if (this.ba.triglyceridesHDLRatio.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_16090);
        }
        if (this.ba.apolipoproteinA1.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_16091);
        } else if (this.ba.apolipoproteinA1.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_16092);
        }
        if (this.ba.apolipoproteinB.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_16094);
        } else if (this.ba.apolipoproteinB.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_16095);
        }
        if (this.ba.apoBapoA1Ratio.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_16097);
        }
        if (this.ba.lipoproteinA.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_16100);
        } else if (this.ba.lipoproteinA.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_16110);
        }

        /*
         * NMR LipoProfile. Each marker fires in ONE direction, the adverse one,
         * which is why these are `if` and not `if/else`: there is no root cause
         * to explain for a low LDL-P or a large HDL particle.
         *
         * Only the particle COUNT and SIZE rows are here. LP-IR has its own
         * category, but the six markers it is COMPUTED from (large VLDL-P,
         * small LDL-P, large HDL-P, VLDL size, LDL size, HDL size — Shalaurova
         * 2014, PMID: 24959989) each still fire on their own, because a root
         * cause list is per marker and a practitioner reading the Large VLDL-P
         * bar wants its causes whether or not LP-IR was ordered. That is NOT the
         * same as the Insights panel's area scoring, which must pick LP-IR or
         * its components and never both — see lipid-patterns-spec.md §6.
         */
        if (this.ba.ldlParticleNumber.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_16120);
        }
        if (this.ba.hdlParticleNumber.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_16130);
        }
        if (this.ba.smallLdlParticleNumber.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_16140);
        }
        if (this.ba.ldlSize.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_16150);
        }
        if (this.ba.largeVldlParticleNumber.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_16160);
        }
        if (this.ba.largeHdlParticleNumber.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_16170);
        }
        if (this.ba.vldlSize.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_16180);
        }
        if (this.ba.hdlSize.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_16190);
        }
        if (this.ba.lpIrScore.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_16200);
        }
    }
}